import api from 'configs/api';

import { IExecutor, IExecutorFilterData } from 'interfaces/Executor';
import { IRequestListResponse } from 'interfaces/RequestListResponse';
import { IRequestResponse } from 'interfaces/RequestResponse';

const endpointUrl = 'executor';

export const postExecutorOptions = async params => {
  const url = `${endpointUrl}/filter/description`;
  const { data } = await api.post<IRequestListResponse<IExecutor>>(url, params);
  return data;
};

export const postExecutorFilter = async (qsparams, params) => {
  const url = `${endpointUrl}/filter?${qsparams}`;
  const { data } = await api.post<IRequestResponse<IExecutorFilterData>>(
    url,
    params,
  );
  return data;
};

export const postExecutorBulletinFilter = async (qsparams, params) => {
  const url = `${endpointUrl}/filterDailyBulletin?${qsparams}`;
  const { data } = await api.post<IRequestResponse<IExecutorFilterData>>(
    url,
    params,
  );
  return data;
};

export const getExecutorOptions = async () => {
  const url = `${endpointUrl}`;
  const { data } = await api.get<IRequestListResponse<IExecutor>>(url);
  return data;
};

export const postTypeArea = async params => {
  const url = `${endpointUrl}/filter/typeArea`;
  const { data } = await api.post<IRequestListResponse<IExecutor>>(url, params);
  return data;
};
